import script from "./WLX2DNoWorker.vue?vue&type=script&setup=true&lang=js"
export * from "./WLX2DNoWorker.vue?vue&type=script&setup=true&lang=js"

import "./WLX2DNoWorker.vue?vue&type=style&index=0&id=5d2910a7&scoped=true&lang=css"

import exportComponent from "D:\\yh\\工厂\\code\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d2910a7"]])

export default __exports__